module.exports = __webpack_public_path__ + "asset/image-iconCategoryTransfer-b37679c5db5ee344.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/iconCategoryTransfer.svg
// module id = RTjd
// module chunks = 0